import { IData } from '@hooks/useData';
import { ICliente } from '@model/Cliente';
import { IClienteSaldo } from '@model/ClienteSaldo';
import { IComboEmpresa } from '@model/Empresa';
import React from 'react';
import { SaldoFilter } from './SaldoFilter';
import { SaldoTable } from './SaldoTable';

export type ClienteDetalhesSaldosProps = {
    data: IData<IClienteSaldo>
    isLoading: boolean
    empresaCombo: IComboEmpresa
    cliente: ICliente

}

export function ClienteDetalhesSaldos ({ data, cliente, empresaCombo, isLoading }: ClienteDetalhesSaldosProps) {
    return (
        <React.Fragment>
            <SaldoFilter 
                cliente={cliente}
                empresaCombo={empresaCombo}
                isLoading={isLoading}
                onSaldoRegistrado={data.filter.handleFilterRequest}
            />

            <SaldoTable 
                data={data}
                isLoading={isLoading}
            />
        </React.Fragment>
    )
}